import React, { ReactElement, useEffect, useRef } from 'react';
import { MapPinView } from '@hotelplan/components.common.map-pin';
import { FdrAgencyFragment } from 'schemas/fragment/agency/fdr-agency.generated';
import { FdrAgencyPinIcon } from './fdr-agency-map-pin-icon';
import { FdrAgencyMapPin } from './fdr-agency-map.styles';
import { getAgencyIcons } from './fdr-agency-map.utils';

interface IFdrAgencyPinProps {
  agency: FdrAgencyFragment;
  selected: boolean;
  onClick(agency: FdrAgencyFragment): void;
  showDetailedInfo?: boolean;
  setActiveAgency?(agencyId: string): void;
}

export function FdrAgencyPin({
  agency,
  onClick,
  selected,
  showDetailedInfo,
  setActiveAgency,
}: IFdrAgencyPinProps): ReactElement {
  const ref = useRef<MapPinView>(null);

  useEffect(() => {
    if (!ref.current) return;

    google.maps.event.trigger(ref.current, selected ? 'select' : 'deselect');
  }, [selected]);

  const { agencyIcon, pinIcon } = getAgencyIcons(agency, selected);

  if (!agency.coordinates) return null;

  return (
    <FdrAgencyMapPin
      viewRef={ref}
      coordinates={agency.coordinates}
      object={agency}
      onClick={onClick}
      initialSelected={selected}
    >
      <FdrAgencyPinIcon
        {...{ agencyIcon, pinIcon, agency, showDetailedInfo, setActiveAgency }}
      />
    </FdrAgencyMapPin>
  );
}
